export class RecentlyViewed {
  static #STORAGE_KEY = 'viewedProducts';
  static #MAX_PRODUCTS = 4;
  static #currentProduct;
  static #watchingPrivacy = false;
  static #requestedPrivacy = false;

  static #preferencesAllowed() {
    try {
      return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed?.() === true;
    } catch {
      return false;
    }
  }

  static #syncPrivacy() {
    if (!this.#preferencesAllowed()) {
      this.clearProducts();
      return;
    }
    if (this.#currentProduct) this.#storeProduct(this.#currentProduct);
  }

  static #requestPrivacy() {
    if (window.Shopify?.customerPrivacy || this.#requestedPrivacy) return;
    if (typeof window.Shopify?.loadFeatures !== 'function') return;
    this.#requestedPrivacy = true;
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        if (!error) this.#syncPrivacy();
      });
    } catch {
      this.clearProducts();
    }
  }

  static #watchPrivacy() {
    if (this.#watchingPrivacy) return;
    this.#watchingPrivacy = true;
    document.addEventListener('visitorConsentCollected', () => this.#syncPrivacy());
    this.#requestPrivacy();
    if (!window.Shopify?.customerPrivacy && !this.#requestedPrivacy) {
      window.addEventListener('load', () => {
        this.#requestPrivacy();
        this.#syncPrivacy();
      }, { once: true });
    }
  }

  static #storeProduct(productId) {
    const viewedProducts = this.getProducts().filter((id) => id !== productId);
    viewedProducts.unshift(productId);
    try {
      localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts.slice(0, this.#MAX_PRODUCTS)));
    } catch {}
  }

  static addProduct(productId) {
    this.#currentProduct = productId;
    this.#watchPrivacy();
    this.#syncPrivacy();
  }

  static clearProducts() {
    try {
      localStorage.removeItem(this.#STORAGE_KEY);
    } catch {}
  }

  static getProducts() {
    this.#watchPrivacy();
    if (!this.#preferencesAllowed()) {
      this.clearProducts();
      return [];
    }
    try {
      const viewedProducts = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
      return Array.isArray(viewedProducts)
        ? viewedProducts.filter((id) => typeof id === 'string').slice(0, this.#MAX_PRODUCTS)
        : [];
    } catch {
      return [];
    }
  }
}
